import { ReactElement, useMemo } from 'react';
import { useList } from 'react-use';
import short from 'short-uuid';
import styled from 'styled-components';

import { TransferDestination } from '../../../generated-api';
import TransferDestinationRow, { TransferDestinationHeader } from './TransferDestinationRow';

const Label = styled.div`
  margin-bottom: 12px;
`;
const Section = styled.div`
  padding: 8px;
  margin-bottom: 24px;
  border: 1px solid #f0f0f0;
  display: grid;
  grid-gap: 8px;
  align-items: center;
  overflow: auto;
  grid-auto-rows: 40px;
`;

type TransferDestinationFormProps = {
  transferDestinations: TransferDestination[];
};

function TransferDestinationForm({ transferDestinations }: TransferDestinationFormProps): ReactElement {
  const destinations = useMemo(() => [...transferDestinations], [transferDestinations]);
  const defaultValue: TransferDestination = useMemo(() => {
    return {
      bank_name: '',
      branchName: '',
      accountType: '',
      accountNumber: '',
      accountHolder: '',
    };
  }, []);

  if (destinations.length === 0) {
    destinations.push(defaultValue);
  }

  const details = useMemo(() => {
    return destinations.reduce<Record<string, TransferDestination>>((accumulator, current) => {
      accumulator[short.generate()] = current;
      return accumulator;
    }, {});
  }, [destinations]);

  const [rowIds] = useList(Object.keys(details));

  return (
    <>
      <Label>振込口座情報</Label>
      <Section>
        <TransferDestinationHeader />
        {rowIds.map((id) => (
          <TransferDestinationRow key={id} transferDestination={details[id] ?? defaultValue} />
        ))}
      </Section>
    </>
  );
}

export default TransferDestinationForm;
